const AboutUs = () => {
	return (
		<section>
			<h2>About section</h2>
		</section>
	);
};

export default AboutUs;
